import UserApi from './UserApi';

export default UserApi;
